import React, { useContext } from 'react';

import { FilterEditorContextProvider } from '../../../components/filter-editor/context';

import { AutomationRulesProvider, AutomationRulesContext } from './context';
import { AutomationRules } from './index';

const AutomationRulesWithFilterEditor = () => {
  const { selectedRule } = useContext(AutomationRulesContext);
  const filterId = selectedRule?.filterId ? String(selectedRule.filterId) : undefined;

  return (
    <FilterEditorContextProvider filterId={filterId}>
      <AutomationRules />
    </FilterEditorContextProvider>
  );
};

export const AutomationRulesPageWrapper = () => (
  <AutomationRulesProvider>
    <AutomationRulesWithFilterEditor />
  </AutomationRulesProvider>
);
